<button class="message-button" mat-button *ngIf="message.closeable" (click)="onCloseClick()"><i class="fa fa-times"></i></button>
<span class="message-image"><i class="{{imageClass}}"></i></span>
<div class="message-content">
    <span class="message-title">{{message.title}}</span>
    <p class="message-message" style="white-space:pre-wrap;">{{message.message}}</p>
</div>